export default {
    setGroups(state, g) {
        state.groups = g;
    }
}